import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-az-selector',
  imports: [],
  templateUrl: './az-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './az-selector.component.scss',
})
export class AzSelectorComponent implements OnDestroy {
  @Input() label = '';
  @Input() options: string[] = [];
  @Input() selectedValue = '';
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<string>();

  @ViewChild('control', { static: false }) controlRef?: ElementRef<HTMLElement>;

  isOpen = false;
  dropdownTop = 0;
  dropdownLeft = 0;
  dropdownWidth = 0;

  private clickListener: ((event: MouseEvent) => void) | null = null;
  private scrollListener: (() => void) | null = null;
  private resizeListener: (() => void) | null = null;

  constructor(private elementRef: ElementRef) {}

  toggleDropdown(): void {
    if (this.disabled) return;

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.updateDropdownPosition();
      this.addListeners();
    } else {
      this.removeListeners();
    }
  }

  updateDropdownPosition(): void {
    const control =
      this.controlRef?.nativeElement ??
      this.elementRef.nativeElement.querySelector('.az-selector__control');
    if (!control) return;
    const rect = control.getBoundingClientRect();
    this.dropdownTop = rect.bottom + 4;
    this.dropdownLeft = rect.left;
    this.dropdownWidth = rect.width;
  }

  selectOption(option: string): void {
    this.selectedValue = option;
    this.selectionChange.emit(option);
    this.closeDropdown();
  }

  closeDropdown(): void {
    this.isOpen = false;
    this.removeListeners();
  }

  private addListeners(): void {
    this.removeListeners();

    setTimeout(() => {
      this.clickListener = (event: MouseEvent) => {
        const target = event.target as Node;
        if (!this.elementRef.nativeElement.contains(target)) {
          this.closeDropdown();
        }
      };
      document.addEventListener('click', this.clickListener, true);
    }, 0);

    this.scrollListener = () => {
      if (this.isOpen) this.updateDropdownPosition();
    };
    this.resizeListener = () => {
      if (this.isOpen) this.updateDropdownPosition();
    };
    window.addEventListener('scroll', this.scrollListener, true);
    window.addEventListener('resize', this.resizeListener);
  }

  private removeListeners(): void {
    if (this.clickListener) {
      document.removeEventListener('click', this.clickListener, true);
      this.clickListener = null;
    }
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener, true);
      this.scrollListener = null;
    }
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
      this.resizeListener = null;
    }
  }

  ngOnDestroy(): void {
    this.removeListeners();
  }
}
